import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './i18n';
import './utils/errorHandler';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { setupAutoSync } from './services/dataSync';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

serviceWorkerRegistration.unregister();

// Setup automatic data synchronization
setupAutoSync();
